import React from "react";

const Details = ({ orders }) => {
  return orders.map((value, index) => {
    return (
      <>
        <div
          className="item details d-lg-flex d-none"
          key={`detail${index * 2}`}
        >
          <div className="itemValue col-3">{value.title}</div>
          <div className="itemValue col-3">{value.total_count}</div>
          <div className="itemValue col-3">{value.total_discount}</div>
          <div className="itemValue col-3">{value.total_amt}</div>
        </div>
        <div
          className="headers_table d-flex d-lg-none flex-wrap"
          key={`detail${index * 2 + 1}`}
        >
          <div className="item col-12 col-md-6">
            عنوان : <span className="itemValue">{value.title}</span>
          </div>
          <div className="item col-12 col-md-6">
            تعداد : <span className="itemValue">{value.total_count}</span>
          </div>
          <div className="item col-12 col-md-6">
            مجموع تخفیفات :
            <span className="itemValue">{value.total_discount}</span>
          </div>
          <div className="item col-12 col-md-6">
            مبلغ کل : <span className="itemValue">{value.total_amt}</span>
          </div>
        </div>
      </>
    );
  });
};

export default Details;
